import './sideInfo.css';

const SideInfo = ({
    elements,
    background,
    noBg,
    is_bg,
    backgroundColor,
}: {
    elements: any[];
    background: string;
    noBg: number[];
    is_bg: boolean;
    backgroundColor?: string;
}) => {
    return (
        <div className="side_info">
            <div
                className="side_info_bg"
                style={{
                    backgroundColor: backgroundColor || "#3db6ae",
                }}
            >
                <div
                    className="side_info_bg__image"
                    style={{
                        backgroundImage: background ? `url(${background})` : "none",
                        backgroundSize: is_bg ? "contain" : "auto 60%",
                    }}
                />
            </div>
            {
                elements.map((element: any) => {
                    return (
                        <div className={`side_info_item ${noBg.find((item: number) => item === elements.indexOf(element)) !== undefined ? 'no_bg' : ''}`} key={elements.indexOf(element)}>
                            {
                                element
                            }
                        </div>
                    )
                })
            }
        </div>
    )
}

export default SideInfo;
